<template>
    <div class="mt-2">
        <b-form-checkbox
            @change="confirmarNaoAditivarContratacao()"
            v-model="naoAditivar"
            :value="true"
            :unchecked-value="false"
        >
            <strong>Essa contratação não será aditivada</strong>
        </b-form-checkbox>
    </div>
</template>

<script>
export default {
    props: {
        contratacao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            naoAditivar: false
        }
    },

    methods: {
        confirmarNaoAditivarContratacao() {
            this.$swal({
                title: 'Contratação',
                html: `Confirma que a contratação ${
                    this.contratacao.codContratacao
                } ${this.naoAditivar ? '' : 'não'} será aditivada?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.naoAditivarContratacao()
                } else {
                    this.naoAditivar = this.naoAditivar ? false : true
                }
            })
        },

        naoAditivarContratacao() {
            this.$emit('naoAditivarContratacao')
        }
    },

    created() {
        this.naoAditivar = this.contratacao.naoAditivar
    },

    computed: {},

    watch: {
        contratacao() {
            this.naoAditivar = this.contratacao.naoAditivar
        }
    },

    validations: {}
}
</script>
